import styled from "styled-components";
import images from "../img";

function LifeStyleContent({
    picture,
    name,
    tag
}) {
    return (<LifeStyleContentStyledWrapper className="lifestyle-content">
        <div className="head">
            <div className="name">
                {name}
            </div>
            <ul className="tag">
                {tag.map((x, i) => <li key={i}>#{x}</li>)}
            </ul>
        </div>
        <div className="body">
            {picture.map((x, i) => <div key={i} className="picture"
                style={{
                    backgroundImage: `url(${images['lifestyle/' + x]})`
                }}
            ></div>)}
        </div>
    </LifeStyleContentStyledWrapper>);
}

export default LifeStyleContent;

const LifeStyleContentStyledWrapper = styled.div`
    display: flex;
    flex-direction: column;
    .picture{
        width:44rem;
        height:29rem;
        margin-bottom:0.8rem;
        background-color: #ccc;
        background-size:cover;
    }
    .head{
        display: flex;
        .name{
            font-size: 2rem;
            font-weight: bold;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.85;
            letter-spacing: normal;
            text-align: left;
            color: #000;
            margin-right:1.5rem;
            margin-bottom:1rem;
        }
        .tag{
            margin: 0;
            list-style: none;
            display: flex;
            padding:0;
            li{
                margin-right:0.6rem;
                font-size: 1.6rem;
                font-weight: normal;
                font-stretch: normal;
                font-style: normal;
                line-height: 2;
                letter-spacing: -0.04rem;
                text-align: left;
                color: #7b0d10;
            }
        }
    }
`;